import React from 'react';
import Blogs from '../Home/Blogs/Blogs';
import Navbar from '../Shared/Navbar/Navbar';

const BlogsPage = () => {
    return (
        <div>
            <Navbar></Navbar>
            <Blogs></Blogs>
        </div>
    );
};

export default BlogsPage;